import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { logger } from "../lib/logger";

const makeId = (p) => `${p}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
const withIds = (list) => (list || []).map((m) => ({ ...m, id: makeId("h") }));

// Shared state for AI chat panels. Session ids live in memory; the latest admin session is restored from the server.
export const useChatSession = ({ prefix, endpoint, latestEndpoint, errorText }) => {
  const [sessionId, setSessionId] = useState(() => makeId(prefix));
  const [messages, setMessages] = useState([]);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!latestEndpoint) return;
    api.get(latestEndpoint)
      .then(({ data }) => {
        if (!data.session_id) return;
        setSessionId(data.session_id);
        setMessages(withIds(data.messages));
      })
      .catch((e) => logger.error("history load failed", e));
  }, [latestEndpoint]);

  const push = (role, content) => setMessages((m) => [...m, { id: makeId(role), role, content }]);

  const send = useCallback(async (text) => {
    if (!text || sending) return;
    push("user", text);
    setSending(true);
    try {
      const { data } = await api.post(endpoint, { session_id: sessionId, message: text });
      push("assistant", data.reply);
    } catch (e) {
      logger.error("chat send failed", e);
      push("assistant", errorText);
    } finally {
      setSending(false);
    }
  }, [sending, endpoint, sessionId, errorText]);

  const reset = () => { setSessionId(makeId(prefix)); setMessages([]); };

  return { messages, sending, send, reset };
};
